import { render, staticRenderFns } from "./CallStaff.vue?vue&type=template&id=068f9720&"
import script from "./CallStaff.vue?vue&type=script&lang=js&"
export * from "./CallStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports